module.exports = __webpack_public_path__ + "assets/425d8f61870d4aa43fca920d7efeadc3.png";